export default __webpack_public_path__ + "static/EvergreenHero-XS-SM-ddd0ea1ffdd1d85258a803a1dc7bf9b0.webp";